import React, { useState } from 'react';
import { X, Save } from 'lucide-react';
import { ResponsePattern } from '../types';
import { generateId } from '../utils/generateId';

interface ResponsePatternModalProps {
  onClose: () => void;
  onSave: (pattern: ResponsePattern) => void;
}

const ResponsePatternModal: React.FC<ResponsePatternModalProps> = ({ onClose, onSave }) => {
  const [trigger, setTrigger] = useState('');
  const [response, setResponse] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (trigger.trim() && response.trim()) {
      const newPattern: ResponsePattern = {
        id: generateId(),
        trigger: trigger.trim(),
        response: response.trim()
      };
      onSave(newPattern);
      setTrigger('');
      setResponse('');
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b border-gray-200 p-6 rounded-t-2xl">
          <div className="flex justify-between items-center">
            <h2 className="text-2xl font-bold text-gray-800">Yeni Yanıt Kalıbı Ekle</h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <X className="h-6 w-6" />
            </button>
          </div>
        </div>
        
        <form onSubmit={handleSubmit} className="p-6">
          <div className="mb-6">
            <label htmlFor="trigger" className="block text-sm font-semibold text-gray-700 mb-3">
              Tetikleyici Kelimeler
            </label>
            <input
              type="text"
              id="trigger"
              value={trigger}
              onChange={(e) => setTrigger(e.target.value)}
              className="w-full p-4 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
              placeholder="Örnek: şikayet, başvuru, problem (virgül ile ayırın)"
              required
            />
            <p className="text-sm text-gray-500 mt-2">
              Birden fazla tetikleyici kelime için virgül (,) karakteri kullanın
            </p>
          </div>
          
          <div className="mb-8">
            <label htmlFor="response" className="block text-sm font-semibold text-gray-700 mb-3">
              Yanıt Metni
            </label>
            <textarea
              id="response"
              value={response}
              onChange={(e) => setResponse(e.target.value)}
              className="w-full p-4 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
              rows={6}
              placeholder="Bu tetikleyici kelimeler için verilecek yanıt..."
              required
            />
          </div>
          
          <div className="flex gap-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-6 py-3 border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 transition-colors"
            >
              İptal
            </button>
            <button
              type="submit"
              disabled={!trigger.trim() || !response.trim()}
              className="flex-1 bg-gradient-to-r from-emerald-500 to-teal-600 text-white px-6 py-3 rounded-xl hover:from-emerald-600 hover:to-teal-700 transition-all flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-xl"
            >
              <Save className="h-5 w-5 mr-2" />
              Kaydet
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResponsePatternModal;